// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar {
  background-color: white;
  position: fixed;
  height: 100%;
  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);
  z-index: 100;
}

.menu-item {}

.menu-item:hover>* {}

.fade-out {
  animation: visible 2s;
}

.calendar {
  border: none;
  background: rgb(249, 249, 249, 0.7);
}

.react-calendar__tile--now {
  background: var(--psyellow)
}

.react-calendar__tile--active,
.react-calendar__tile--range,
.react-calendar__tile--rangeStart,
.react-calendar__tile--rangeEnd,
.react-calendar__tile--rangeBothEnds,
.react-calendar__tile--active:enabled:hover,
.react-calendar__tile--active:enabled:focus {
  background: var(--psblue);
}
.react-calendar__tile--now:enabled:hover {
  background: var(--psyellow);
}
.react-calendar__tile--now:enabled:focus {
  background: var(--psblue);
  color: white;
}
.react-calendar__tile--hasActive {
  background: none;
}

@keyframes visible {

  0%,
  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/sidebar/sidebar.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,wCAAwC;EACxC,YAAY;AACd;;AAEA,YAAY;;AAEZ,oBAAoB;;AAEpB;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE;AACF;;AAEA;;;;;;;EAOE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;;AAEA;;EAEE;;IAEE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".sidebar {\n  background-color: white;\n  position: fixed;\n  height: 100%;\n  box-shadow: 0 0 0.5cm rgba(0, 0, 0, 0.5);\n  z-index: 100;\n}\n\n.menu-item {}\n\n.menu-item:hover>* {}\n\n.fade-out {\n  animation: visible 2s;\n}\n\n.calendar {\n  border: none;\n  background: rgb(249, 249, 249, 0.7);\n}\n\n.react-calendar__tile--now {\n  background: var(--psyellow)\n}\n\n.react-calendar__tile--active,\n.react-calendar__tile--range,\n.react-calendar__tile--rangeStart,\n.react-calendar__tile--rangeEnd,\n.react-calendar__tile--rangeBothEnds,\n.react-calendar__tile--active:enabled:hover,\n.react-calendar__tile--active:enabled:focus {\n  background: var(--psblue);\n}\n.react-calendar__tile--now:enabled:hover {\n  background: var(--psyellow);\n}\n.react-calendar__tile--now:enabled:focus {\n  background: var(--psblue);\n  color: white;\n}\n.react-calendar__tile--hasActive {\n  background: none;\n}\n\n@keyframes visible {\n\n  0%,\n  50% {\n    opacity: 1;\n  }\n\n  100% {\n    opacity: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
